import { remittanceConfig } from "@/config/remittance";

const imageAssets = {
  appleStartup: "/assets/images/icon.png",
  favicon: "/assets/images/favicon.png",
  appleTouchIcon512: "/assets/images/icon.png",
  openGraph: "/assets/images/og-image.png",
  loaderLogo: "/assets/images/cymonz-loader-logo.png",
};

const { companyName, contactDetails } = remittanceConfig;

export const registrationText = {
  createAccountHeader: `Create your ${companyName} account`,
  termsAgreementPrefix: `I agree to the ${companyName}`,
};

export const appConstants = {
  companyName,
  emailAddress: contactDetails.supportEmail,
  contactPhoneNumber: contactDetails.supportPhone,
  infoEmail: contactDetails.infoEmail ?? "",
  whatsappNumber: contactDetails.whatsappNumber ?? "",
  defaultPageTitle: `${companyName} - Worldwide money transfers`,
  titleTemplateSuffix: companyName,
  description:
    "Cymonz offer a highly scalable and configurable international payments and currency exchange platform for Banks, Remittance, MSB's, Retail Chains and FinTech's.",
  images: imageAssets,
};
